export const GETTING_STARTED_DISMISSED_KEY = "join_getting_started_dismissed";

export type GettingStartedEnvironment = {
  dismissed: boolean;
  friendsCount: number;
  hasOwnPlan: boolean;
};

export function hasDismissedGettingStarted(): boolean {
  try {
    return window.localStorage.getItem(GETTING_STARTED_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissGettingStarted() {
  try {
    window.localStorage.setItem(GETTING_STARTED_DISMISSED_KEY, "1");
  } catch {
    // The card still hides for the current session if storage is unavailable.
  }
}

// Anti-annoyance rules, in order:
// - a permanent dismissal always wins;
// - the card only exists while the user is genuinely new (missing friends or a
//   first own plan) -- once both are in place it disappears for good, even if
//   the optional install step was never done. Established users never see it.
export function shouldShowGettingStarted(environment: GettingStartedEnvironment): boolean {
  if (environment.dismissed) return false;
  return environment.friendsCount === 0 || !environment.hasOwnPlan;
}
